import React, {FormEvent, RefObject, useRef} from 'react';
import {makeStyles, Theme} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {Button, Grid} from '@material-ui/core';
import {createStyles} from '@material-ui/styles';
import PropTypes, {InferProps} from 'prop-types';
import {updateMsg} from '@betrue/store'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      margin: theme.spacing(1),
      height: 38,
    },
  })
);

export function ElementorWidgetsInput({
                                        textFieldLabel,
                                        handleSubmit,
                                        buttonLabel,
                                        inputRef,
                                      }: {
  textFieldLabel: string,
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void,
  buttonLabel: string,
  inputRef: RefObject<HTMLInputElement>,
}) {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column-reverse"
      justifyContent="center"
      alignItems="center"
    >
      <form onSubmit={handleSubmit}>
        <TextField
          InputProps={{
            className: classes.input,
          }}
          type="text "
          label={textFieldLabel ? textFieldLabel : 'Type a new title'}
          variant="outlined"
          inputRef={inputRef}
        />
        <Button className={classes.input} type="submit" variant="outlined">
          {buttonLabel ? buttonLabel : 'Update title'}
        </Button>
      </form>
    </Grid>
  );
}

/**
 * Same component linked to the store
 */
export function ElementorWidgetsGqlInputStore(props: InferProps<typeof ElementorWidgetsGqlInputStore.propTypes>) {
  const input: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateMsg(input.current.value)
    input.current && (input.current.value = '');
    input.current && input.current.focus();
  };
  return (
    <ElementorWidgetsInput
      textFieldLabel={props.placeHolder}
      buttonLabel={props.button}
      handleSubmit={(e: FormEvent<HTMLFormElement>) => handleSubmit(e)}
      inputRef={input}
    />
  );
}

/**
 * Exposing props to elementor through the web component
 */
ElementorWidgetsGqlInputStore.propTypes = {
  placeHolder: PropTypes.string,
  button: PropTypes.string,
};

